import React from 'react'
import { Card, Container, Row, Col } from 'reactstrap'
import { FaUser } from "react-icons/fa";
import { CgOrganisation } from "react-icons/cg";
import { useNavigate } from 'react-router-dom';
import IconCardButton from './IconCardButton ';
import { FaProductHunt } from "react-icons/fa";
import { MdOutlinePayment } from "react-icons/md";

const SuperAdminDash = () => {
  const navigate = useNavigate();

  return (
    <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <Card  className="shadow">
        <Row className="justify-content-center">
          <Col xs="auto">
            <IconCardButton icon={FaUser} title="Users" onClick={() => navigate('/users')} />
          </Col>
          <Col xs="auto">
            <IconCardButton icon={CgOrganisation} title="Organization" onClick={()=> navigate('/organizations')}/>
          </Col>
          <Col xs="auto">
            <IconCardButton icon={FaProductHunt} title="Products" onClick={()=> navigate('/products')}/>
          </Col>
          <Col xs="auto">
            <IconCardButton icon={MdOutlinePayment} title="Payments" onClick={()=> navigate('/payment-analytics')}/>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default SuperAdminDash
